import React, { Component } from "react";
import { monthOptions, yearOptions } from "../../config";
import * as R from "ramda";
import { configYearToDateLeasing, configYearToDatePayment, transformResponseYearsToDateToTablePayment, transformResponseYearsToDateToTableLeasing } from "../config";
import { mapToObjectDDL, removeNullFields } from "../../../../common/mapper";
import { fetchDataAsync } from "../../../../../Services/Utils";
import Api from "../../../../../Services/Api";
import FlexView from "react-flexview";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import { HttpStatus } from "../../../../common/Constants";

class YearToDateReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            year: null,
            dataSales: [],
            sales: null,
            tableConfigPayment: [],
            tableConfigLeasing: [],
            dataTablePayment: [],
            dataTableLeasing: [],
        };
    };

    componentDidMount = async () => {
        this.setState((prevValue) => ({
            ...prevValue,
            year: yearOptions.find(item => R.equals(item.value, new Date().getFullYear())),
            tableConfigPayment: configYearToDatePayment(),
            tableConfigLeasing: configYearToDateLeasing(),
        }));
        if (!R.isNil(this.props.search) && R.equals(this.props.tab, "salesman")) {
            await this.fetchDataSales();
        }
    };

    componentDidUpdate = async (prevProps, prevState, snapshot) => {
        if (!R.equals(prevProps.search, this.props.search)) {
            if (R.equals(this.props.tab, "salesman")) await this.fetchDataSales();
            this.fetchData()
        }
    };

    fetchData = async () => {
        try {
            this.props.triggerLoading();
            const request = {
                kodeCabang: [this.props.search],
                year: this.state.year?.value,
                // employeeIdTeamLeader: this.props.tab === "salesman" ?  this.props.idLeader : null,
                employeeIdTeamLeader: this.props.idLeader ,
                employeeIdSales: this.state.sales?.value
            };
            const res = await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_REPORT_DTO").getLaporanPenjualanYTDMetodePembayaranDanLeasing,
                setError: this.props.setError,
                menuName: "Dashboard Level Kepala Cabang Keatas - Laporan Jualan Year To Date",
                args: request,
            });

            if (res.ok && res.data.status === HttpStatus.SUCCESS) {
                this.setState((prevValue) => ({
                    ...prevValue,
                    dataTablePayment: transformResponseYearsToDateToTablePayment(res.data.data),
                    dataTableLeasing: transformResponseYearsToDateToTableLeasing(res.data.data),
                }));
            }
            this.props.triggerLoading();
        } catch (error) {
            this.props.triggerLoading();
            console.log("errors: ", error);
        }
    };

    fetchDataSales = async () => {
            const { triggerLoading, setError, tab, search } = this.props;
            triggerLoading();
        
            const isSales = tab === "salesman";
            const fn = isSales ? "getSalesDropdownForDashboard" : "getAllMasterSales";
        
            let res = await fetchDataAsync({
              asyncFn: Api.create("NAGAMAS_MASTER_DATA")[fn],
              setError: setError,
              menuName: "Dashboard Level Team Leader - Laporan Harian By Salesman/CS",
              args: isSales
                ? { employeeIdTeamLeader: this.props.idLeader, kodeCabang: search }
                : { paramFilters: { kodeCabang: search } },
            });
            triggerLoading();
            if (res.ok && res.data.status === HttpStatus.SUCCESS) {
              const label = isSales ? "name" : "salesLeadName";
              this.setState((prevValue) => ({
                ...prevValue,
                dataSales: res.data.data?.map((item) =>
                  mapToObjectDDL(item[label], item.employeeId)
                ),
              }));
            }
          };

    handleSearchValueChange = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            [name]: value,
        }));
    };

    handleSearch = () => {
        this.setState(prev=>({
            ...prev,
            tableConfigPayment: configYearToDatePayment(prev.year?.value),
            tableConfigLeasing: configYearToDateLeasing(prev.year?.value),
        }), () => this.fetchData())
    }

    render() {
        return (
            <>
                <FlexView style={{ gap: "20px", alignItems: "center" }}>
                    <SimpleDDL
                        id="select_options_year"
                        box="search"
                        name="year"
                        containerclassname="width width-250px"
                        placeholder="Tahun"
                        menuPosition="fixed"
                        options={yearOptions}
                        isClearable
                        value={this.state.year}
                        onChange={(value, { name }) => this.handleSearchValueChange(name, value)}
                    />
                    {R.equals(this.props.tab, "salesman") && (
                        <SimpleDDL
                            id="select_options_sales"
                            box="search"
                            name="sales"
                            containerclassname="width width-250px"
                            placeholder="Select Salesman/CS"
                            menuPosition="fixed"
                            isClearable
                            options={this.state.dataSales}
                            value={this.state.sales}
                            onChange={(value, { name }) => this.handleSearchValueChange(name, value)}
                        />
                    )}
                    <SimpleButton
                        styles={{ marginBottom: "15px" }}
                        onClick={() => this.handleSearch()}
                    >Cari</SimpleButton>
                </FlexView>
                <SimpleDataTable
                    data={this.state.dataTablePayment}
                    columns={this.state.tableConfigPayment}
                />
                <FlexView style={{ marginBottom: "15px" }} />
                <SimpleDataTable
                    data={this.state.dataTableLeasing}
                    columns={this.state.tableConfigLeasing}
                />
            </>
        );
    };
}

export default YearToDateReport;